/**
 * Champions Dashboard - Champions Directory Page
 * Lake Charles Landing Page - Modern Migration
 *
 * Route: /champions/dashboard/directory
 */
import React from 'react';
import { ChampionsDashboardLayout } from '../../components/champions/dashboard/ChampionsDashboardLayout';
import { ChampionsDirectory } from '../../components/champions/dashboard/ChampionsDirectory';

export function ChampionsDirectoryPage() {
  // TODO: Replace with actual Champion data from backend/store
  const championName = 'Sarah Johnson';
  const championNumber = 3;

  return (
    <ChampionsDashboardLayout championName={championName} championNumber={championNumber}>
      <ChampionsDirectory />
    </ChampionsDashboardLayout>
  );
}

export default ChampionsDirectoryPage;
